"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const field = yup.object({
    field: yup.string().required(),
});
let condition = yup.object({
    fields: yup.array().of(field),
    type: yup.string().oneOf(['AND', 'OR']),
});
// Required since TypeScript doesn't like recursive definitions
condition = condition.concat(yup.object({
    condition: yup.array().of(condition),
}));
const threshold = yup.object({
    threshold: yup.number().required(),
    conditions: yup.array().required().of(condition),
});
const jurisdiction = yup.object({
    thresholds: yup.array().required().of(threshold),
    countryCode: yup.string().required(),
    currency: yup.string().required(),
});
const rules = yup.array().required().of(jurisdiction);
exports.default = rules;
